import { useEffect, useState } from 'react';
import { getAllCompany, softDeleteCompany } from '../../services/company/listCompanyService.js';

export const useCompanyList = () => {
    const [companies, setCompanies] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    // modales / selección
    const [companyToDelete, setCompanyToDelete] = useState(null);
    // feedback
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    // ordenamiento
    const [sortField, setSortField] = useState('');
    const [sortOrder, setSortOrder] = useState('asc');

    useEffect(() => {
        loadCompanies();
    }, []);

    const loadCompanies = async () => {
        const data = await getAllCompany();
        data.sort((a, b) => a.name.localeCompare(b.name));
        setCompanies(data);
    };

    const confirmDelete = async () => {
        try {
            await softDeleteCompany(companyToDelete.id);
            setCompanies(prev => prev.filter(u => u.id !== companyToDelete.id));
            setSuccess('Empresa eliminada correctamente.');
        } catch (err) {
            if (err.response?.status === 400) {
            // Mensaje de negocio enviado por el backend
            setError(err.response.data?.error || 'No se puede eliminar la empresa.');
            } else if (err.response?.status === 404) {
                setError('La empresa no existe o ya fue eliminada.');
            } else {
                setError('Error inesperado al eliminar la empresa.');
            }
        } finally {
            setCompanyToDelete(null);
        }
    };

    const handleSort = (field) => {
        const order = sortField === field && sortOrder === 'asc' ? 'desc' : 'asc';

        setSortField(field);
        setSortOrder(order);

        setCompanies(prev =>
            [...prev].sort((a, b) => {
                const aValue = field.split('.').reduce((o, i) => o?.[i], a);
                const bValue = field.split('.').reduce((o, i) => o?.[i], b);

                if (aValue < bValue) return order === 'asc' ? -1 : 1;
                if (aValue > bValue) return order === 'asc' ? 1 : -1;
                return 0;
            })
        );
    };

    return {
        companies,
        searchTerm,
        setSearchTerm,
        currentPage,
        setCurrentPage,
        itemsPerPage,
        companyToDelete,
        setCompanyToDelete,
        confirmDelete,
        error,
        setError,
        success,
        setSuccess,
        sortField,
        sortOrder,
        setSortField,
        setSortOrder,
        handleSort
    };
}